const rideSteps = [
  {
    element: '[data-tour="ride-info"]',
    popover: {
      title: "Ride Details",
      description: "Route, departure time, fare, available seats, and current status — all at a glance.",
    },
  },
  {
    element: '[data-tour="ride-map"]',
    popover: {
      title: "Route Map",
      description: "See the driving route on the map with estimated distance and direction.",
    },
  },
  {
    element: '[data-tour="ride-passengers"]',
    popover: {
      title: "Passengers",
      description: "View who's booked this ride. The driver can check passengers in and manage the list.",
    },
  },
  {
    element: '[data-tour="ride-chat"]',
    popover: {
      title: "Ride Chat",
      description: "Coordinate with the driver and other passengers in real-time. Messages are ride-specific.",
    },
  },
  {
    element: '[data-tour="ride-actions"]',
    popover: {
      title: "Actions",
      description: "Book a seat, save the ride, or manage it if you're the driver. Actions change based on ride status.",
    },
  },
];

export default rideSteps;
